import * as React from 'react';
import { useHeader } from './useHeader';
import uuid from 'react-uuid';
import { UserMenu } from '../../UserMenu/UserMenu';

export const Header = () => {
  const { role, token, navigateTo } = useHeader();
  return (
    <div className="container p-0">
      <nav className="navbar pb-3 pt-3 navbar-expand-sm bg-light">
        <div className="container-fluid">
          {(!role || !token) && (
            <>
              <img
                className="img-fluid"
                src="/img/connect_logo.svg"
                alt="Adriana Accounting logo"
                width="240"
                height="192"
              />
              <div className="my-3 my-sm-0">
                <button
                  onClick={() => navigateTo('/login')}
                  className="btn rounded-0 box-shadow-btn bg-primary text-uppercase text-nowrap px-4 py-2 fs-5 text-white fw-bold"
                >
                  Belépés könyvelőként
                </button>
                <button
                  onClick={() => navigateTo('/', { state: { targetId: '#loginPanel', trigger: uuid() } })}
                  className="btn rounded-0 box-shadow-btn bg-primary text-uppercase text-nowrap px-4 py-2 fs-5 text-white fw-bold ms-md-3 my-1"
                >
                  Belépés vállalkozóként
                </button>
              </div>
            </>
          )}
          {role && token && (
            <>
              <a href="/companies">
                <img
                  className="img-fluid"
                  src="/img/connect_logo.svg"
                  alt="Adriana Accounting logo"
                  width="240"
                  height="192"
                />
              </a>
              <UserMenu />
            </>
          )}
        </div>
      </nav>
    </div>
  );
};
